import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import * as R from 'ramda';
import {EhpadDetails} from './ehpadDetails';
import { FrenchTypes } from '../../../../../constants/utils/connectionTypes';

export const Ehpad = () => {
    const [ehpadState, setEhpadState] = useState({
        items: []
    });

    const services = useSelector(state => state.services);
    const user = useSelector(state => state.user);
    
    const serviceData = R.isNil(services.serviceData[FrenchTypes.ehpad]) ? [] : services.serviceData[FrenchTypes.ehpad];
    useEffect(() => {
        let leaseInState = serviceData.filter(s => s.serviceType === FrenchTypes.ehpad);
        if (leaseInState.length > 0){
            setEhpadState({
                items: leaseInState
            });
        }else{
            setEhpadState({...ehpadState, items: ehpadState.items.concat({})});
        }
    }, [services.serviceData]);

    function removeActivity(ehpad) {
        setEhpadState({...ehpadState, items: ehpadState.items.filter(a => a !== ehpad)});
    }

    return (
        <article className="block" id="activité">
            <h3 className="sr-only visually-hidden">Bail</h3>
            {
                ehpadState.items.map((activity, index) => {
                    return <EhpadDetails key={index} index={index} userId={user.user.id} activity={activity} removeActivity={removeActivity} />
                })
                    
            }
            
            <footer className="block sticky-auto b-auto-0 z-2 mx-auto text-center bg-light pt-4 pb-1">
                <h4 className="sr-only visually-hidden">Ajouter un autre BAIL</h4>
                <button type="button" className="btn btn-icon btn-alert-info mx-auto py-2" onClick={(e) => {
                    const nodes = window.document.querySelectorAll('.collapse.show');
                    if (!R.isNil(nodes) && nodes.length > 0) {
                        nodes.forEach(element => {
                            element.classList.remove(['show']);
                        });
                    }
                    setEhpadState({...ehpadState, items: ehpadState.items.concat({
                        type: 'Ehpad',
                        name: "",
                        addressStreet1: "",
                        addressStreet2: "",
                        addressPostalCode: "",
                        addressLocality: "",
                        addressCountry: "FR"
                    })});
                }}>
                    <i className="eva eva-person-add-outline h3 my-auto mr-2"></i>Ajouter un autre BAIL
				</button>
            </footer>
        </article>
    )
}